'use strict';

import axios from 'axios';
import store from '@/store';
import { getAllPromise } from '@/utils/const';
import { objKeySort } from '@/filters';
import { showToast, Toast } from 'vant'
// import md5 from 'js-md5';

// 完整配置参考:  https://github.com/axios/axios#request-config
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';

/* eslint-disable */
let config = {
  baseURL: process.env.BASE_URL || process.env.VUE_APP_UPLOAD_URL || process.env.VUE_APP_TMC_URL || '',
  timeout: 60 * 1000,
  withCredentials: false,
  crossDomain: true,
  transformRequest: [
    data => {
      if (!data || typeof data === 'string') {
        return data;
      }
      if (data instanceof FormData) {
        return data;
      }
      // 对Blob对象进行处理
      let hasBlob = Object.values(data).some(it => {
        return it instanceof Blob;
      });
      if (!hasBlob) {
        return JSON.stringify(data);
      }
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
      });
      return formData;
    }
  ]
};

const _axios = axios.create(config);

// 注册all方法，执行多个并发请求
// 可传入Promise、包含Promise的数组、返回值为Promise的方法
_axios.all = (...requsets) => {
  // 获取所有Promise对象
  let promiseList = getAllPromise(requsets);
  return new Promise((resolve, reject) => {
    axios.all(promiseList)
      .then(axios.spread((...response) => {
        // 两个请求现在都执行完成
        resolve(response);
      }))
      .catch(error => {
        reject(error);
      });
  });
};

_axios.interceptors.request.use(
  config => {
    if (config.url.includes('api/sys/file')) {
      // 上传图片请求，不带请求头参数
    } else if (config.url.includes("openRemoteInquiry/order/apply")) {
      config.headers["token"] = "rp_pdd_plugin-b995b66bb47574ca0d1a9e9e238a0a6b";
      config.headers["bizID"] = "22020824";
      config.headers["authMethod"] = "token";
    } else {
      // let paramsNew = '';
      // if (config.method === 'get' && config.params) {
      //   // 每次请求需要带上进入时在url中的四个参数
      //   for (let key of Object.keys(store.getters.urlParams)) {
      //     config.params[key] = store.getters.urlParams[key]
      //   }
      //   paramsNew = objKeySort(config.params);
      // } else if (config.method === 'post' && config.data) {
      //   // 每次请求需要带上进入时在url中的四个参数
      //   for (let key of Object.keys(store.getters.urlParams)) {
      //     config.data[key] = store.getters.urlParams[key]
      //   }
      //   paramsNew = objKeySort(config.data);
      // }
      // config.headers.common['userSig'] = 'userSig';
      // config.headers.common['clientType'] = 'h5';
      // config.headers.common['version'] = 'v2.2';
      // config.headers.common['timestamp'] = dateChange();
      // config.headers.common['sign'] = store.getters.urlParams.sign === '%24%7Bsign%7D' || store.getters.urlParams.sign === '' ? md5(encodeURIComponent(paramsNew + config.headers.common.clientType + config.headers.common.timestamp + 'n8R7vPaF3nJc')) : store.getters.urlParams.sign;
      // config.headers.common['sign'] = md5(encodeURIComponent(paramsNew + config.headers.common.clientType + config.headers.common.timestamp + 'n8R7vPaF3nJc'));
      config.headers.common['token'] = store.getters.urlParams['token'];
      config.headers.common['authMethod'] = "token";
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 拦截响应
_axios.interceptors.response.use(
  response => {
    // 用来判断是否请求成功
    const success = response.status === 200 && (response.data.code === '20000' || response.data.code === 0);
    let message = '';
    if (!success) {
      if (typeof response.data === 'string') {
        message = '服务器错误，未获取到响应数据';
      } else {
        if (response.status === 200 && (response.data.code === '20000' || response.data.code === 0)) {
          return Promise.reject(response);
        }
        // 请求成功，但在业务上为失败
        message = response.data.message || response.data.errorData || '操作执行失败';
      }
      showToast(message)
      return Promise.reject(response);
    }
    return {
      data: response.data.data,
      orderThemeContext: response.config.orderThemeContext,
      success,
      message
    };
  },
  error => {
    let message = '';
    if (!navigator.onLine) {
      message = '网络连接异常，请检查网络';
      showToast(message);
      return Promise.reject(error);
    }
    if (!error.response) {
      message = '连接服务器失败';
      showToast(message);
      return Promise.reject(error);
    }
    let status = error.response.status;
    if (status === 401) {
      message = '登录已失效，请退出重新进入';
      store.dispatch('logout');
      showToast(message);
      return Promise.reject(error);
    }
    if (status < 200) {
      message = `未处理的消息响应，状态码：${status}`;
    } else if (status >= 300 && status < 400) {
      message = `未处理的重定向响应，状态码：${status}`;
    } else if (status >= 400 && status < 500) {
      message = `客户端错误，状态码：${status}`;
    } else if (status >= 500) {
      message = `服务器错误，状态码：${status}`;
    }
    showToast(message);
    // 系统请求失败
    return Promise.reject(error);
  }
);

export default _axios;
